import { Outlet, createRoute } from '@tanstack/react-router'
import { Route as authenticatedRoute } from './route'

export const Route = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: '/collections',
  component: () => <Outlet />,
})
